import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving Tailwind conflicts in favour of the last one.
 *
 * `clsx` alone would produce "p-2 p-4" and let CSS source order decide — which
 * is not what a caller passing `className="p-4"` to a component with a `p-2`
 * default means. `twMerge` makes the override actually override.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
